import { Device, ImportSchedule, Sensor, SensorGroup, UserAccessRole, UserGroup } from "@models";
import { ChartFavoriteInfo } from "@models/ChartFavorite/chartfavoriteInfo.model";
import { ImageFavoriteInfo } from "@models/ImageFavorite/imageFavoriteInfo.model";
import { MapFavoriteInfo } from "@models/MapFavorite/mapFavoriteInfo.model";
import { DashboardInfo } from "@models/Dashboard/dashboardInfo.model";
import { Event } from "@models/Event/Event.model";
import { ActionQueue } from "@models/ActionQueue/ActionQueue.model";
import { Scoutview } from "@models/Scoutview/scoutview.model";

export interface Authorization {
    mapUserAccessForUserGroup(userGroup: UserGroup, globalSwitch: boolean, userName: string, adminGroup: UserGroup);
    mapUserAccessForChart(chart: ChartFavoriteInfo, globalSwitch: boolean, userName: string, userGroups: UserGroup[]);
    mapUserAccessForDashboard(dashboard: DashboardInfo, globalSwitch: boolean, userName: string, userGroups: UserGroup[]);
    mapUserAccessForImports(importSchedule: ImportSchedule, globalSwitch: boolean, userName: string, userGroups: UserGroup[]);
    mapUserAccessForDevice(device: Device, globalSwitch: boolean, userName: string, userGroups: UserGroup[]);
    mapUserAccessForSensorGroup(sensorGroup: SensorGroup, globalSwitch: boolean, userName: string, userGroups: UserGroup[]);
    mapUserAccessForEvent(event: Event, globalSwitch: boolean, userName: string, userGroups: UserGroup[]);
    mapUserAccessForSensor(sensor: Sensor, globalSwitch: boolean, userName: string, userGroups: UserGroup[]);

    getUserRoleForUserGroup(userGroup: UserGroup, userName: string, adminGroup: UserGroup): UserAccessRole;
    getUserRoleForChart(chart: ChartFavoriteInfo, userName: string, userGroups: UserGroup[]): UserAccessRole;
    getUserRoleForDashboard(dashboard: DashboardInfo, userName: string, userGroups: UserGroup[]): UserAccessRole;
    getUserRoleForImports(importSchedule: ImportSchedule, userName: string, userGroups: UserGroup[]): UserAccessRole;
    getUserRoleForDevice(device: Device, userName: string, userGroups: UserGroup[]): UserAccessRole;
    getUserRoleForSensorGroup(sensorGroup: SensorGroup, userName: string, userGroups: UserGroup[]): UserAccessRole;
    getUserRoleForEvent(event: Event, userName: string, userGroups: UserGroup[]): UserAccessRole;
    getUserRoleForSensor(sensor: Sensor, userName: string, userGroups: UserGroup[]): UserAccessRole;
}

export class Authorization {
  
    constructor() {}


    mapUserAccessForUserGroup(userGroup: UserGroup, globalSwitch: boolean, userName: string, adminGroup: UserGroup) {
        var userRole = this.getUserRoleForUserGroup(userGroup, userName, adminGroup);

        userGroup.userFeatureAccess = {};

        userGroup.userFeatureAccess["EditUserGroup"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;

        userGroup.userFeatureAccess["DeleteUserGroup"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;

        userGroup.userFeatureAccess["EditUserRole"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;

        userGroup.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }


    getUserRoleForUserGroup(userGroup: UserGroup, userName: string, adminGroup: UserGroup): UserAccessRole {
        var userRole: UserAccessRole = UserAccessRole.Unassigned;

        var adminRole = this.isUserInAdmins(userName, [adminGroup]);
        if (adminRole != UserAccessRole.Unassigned) {
            return adminRole;
        }

        var userInGroup = userGroup.userInfos.find(u => u.userName.toLowerCase() === userName.toLowerCase());
        if (userInGroup == undefined) return userRole;

        return userInGroup.role;
    }

    //--------------------

    mapUserAccessForChart(chart: ChartFavoriteInfo, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        //var userRole = this.getUserRoleForChart(chart, userName, userGroups);
        var [userRole, userGroupName] = this.getUserRole(chart.userGroupId, chart.userName, userName, userGroups);
        chart.userGroup = userGroupName;

        chart.userFeatureAccess = {};
    
        chart.userFeatureAccess["EditChart"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        chart.userFeatureAccess["DeleteChart"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        chart.userFeatureAccess["ViewChart"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ) ? true : false;
    
        chart.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }
    
    //--------------------

    mapUserAccessForImageFavorite(imageFavorite: ImageFavoriteInfo, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        var [userRole, userGroupName] = this.getUserRole(imageFavorite.userGroupId, imageFavorite.userName, userName, userGroups);
        imageFavorite.userGroup = userGroupName;

        imageFavorite.userFeatureAccess = {};

        imageFavorite.userFeatureAccess["EditImageFavorite"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;

        imageFavorite.userFeatureAccess["DeleteImageFavorite"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;

        imageFavorite.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }

    //--------------------

    mapUserAccessForMapFavorite(mapFavorite: MapFavoriteInfo, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        var [userRole, userGroupName] = this.getUserRole(mapFavorite.userGroupId, mapFavorite.userName, userName, userGroups);
        mapFavorite.userGroup = userGroupName;

        mapFavorite.userFeatureAccess = {};

        mapFavorite.userFeatureAccess["EditMapFavorite"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;

        mapFavorite.userFeatureAccess["DeleteMapFavorite"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;

        mapFavorite.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }

    //--------------------

    mapUserAccessForDashboard(dashboard: DashboardInfo, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        //var userRole = this.getUserRoleForDashboard(dashboard, userName, userGroups);
        var [userRole, userGroupName] = this.getUserRole(dashboard.userGroupId, dashboard.userName, userName, userGroups);
        dashboard.userGroup = userGroupName;

        dashboard.userFeatureAccess = {};
    
        dashboard.userFeatureAccess["EditDashboard"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        dashboard.userFeatureAccess["DeleteDashboard"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        dashboard.userFeatureAccess["ViewDashboard"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ) ? true : false;
    
        dashboard.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }

    //--------------------

    mapUserAccessForImports(importSchedule: ImportSchedule, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        var [userRole, userGroupName] = this.getUserRole(importSchedule.userGroupId, importSchedule.userName, userName, userGroups);

        importSchedule.userFeatureAccess = {};
    
        importSchedule.userFeatureAccess["EditSchedule"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        importSchedule.userFeatureAccess["DeleteSchedule"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        importSchedule.userFeatureAccess["CopySchedule"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        importSchedule.userFeatureAccess["ViewSchedule"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ) ? true : false;
    
        importSchedule.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }

    //--------------------

    mapUserAccessForDevice(device: Device, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        var [userRole, userGroupName] = this.getUserRole(device.userGroupId, device.userName, userName, userGroups);
        device.userGroup = userGroupName;

        device.userFeatureAccess = {};
    
        device.userFeatureAccess["EditDevice"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ) ? true : false;
    
        device.userFeatureAccess["DeleteDevice"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        device.userFeatureAccess["RunAdvancedCommands"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        device.userFeatureAccess["ViewDevice"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ) ? true : false;
    
        device.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }

    //--------------------

    mapUserAccessForScoutviewDevice(svDevice: Scoutview, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        var [userRole, userGroupName] = this.getUserRole(svDevice.userGroupId, svDevice.userName, userName, userGroups);
        svDevice.userGroup = userGroupName;

        svDevice.userFeatureAccess = {};
    
        svDevice.userFeatureAccess["CaptureImages"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        svDevice.userFeatureAccess["ViewImages"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ) ? true : false;
    }

    //--------------------

    mapUserAccessForSensorGroup(sensorGroup: SensorGroup, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        var [userRole, userGroupName] = this.getUserRole(sensorGroup.userGroupId, sensorGroup.userName, userName, userGroups);
        sensorGroup.userGroup = userGroupName;

        sensorGroup.userFeatureAccess = {};
    
        sensorGroup.userFeatureAccess["EditSensorGroup"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        sensorGroup.userFeatureAccess["DeleteSensorGroup"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        sensorGroup.userFeatureAccess["EditSensorGroupName"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ) ? true : false;
    
        sensorGroup.userFeatureAccess["ViewSensorGroup"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ) ? true : false;
    
        sensorGroup.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }
    
    //--------------------

    mapUserAccessForEvent(event: Event, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        var [userRole, userGroupName] = this.getUserRole(event.userGroupID, event.userName, userName, userGroups);
        event.userGroup = userGroupName;

        event.userFeatureAccess = {};
    
        event.userFeatureAccess["EditThreshold"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ) ? true : false;
    
        event.userFeatureAccess["EvaluateEvent"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ) ? true : false;
    
        event.userFeatureAccess["TriggerActions"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ) ? true : false;
    
        event.userFeatureAccess["EnableEvent"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ) ? true : false;
    
        event.userFeatureAccess["EditEvent"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        event.userFeatureAccess["DeleteEvent"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        event.userFeatureAccess["CopyEvent"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        event.userFeatureAccess["ViewEvent"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ) ? true : false;
    
        event.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch ) ? true : false;
    }

    //--------------------

    mapUserAccessForActionQueue(actionQueue: ActionQueue, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        var [userRole, userGroupName] = this.getUserRole(actionQueue.userGroupId, actionQueue.userName, userName, userGroups);
        actionQueue.userGroupName = userGroupName;

        actionQueue.userFeatureAccess = {};
        
        actionQueue.userFeatureAccess["EditActionQueue"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
    
        actionQueue.userFeatureAccess["DeleteActionQueue"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;
        
        actionQueue.userFeatureAccess["CopyActionQueue"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ) ? true : false;

        actionQueue.userFeatureAccess["ViewActionQueue"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ) ? true : false;    
    }

    //--------------------

    mapUserAccessForSensor(sensor: Sensor, globalSwitch: boolean, userName: string, userGroups: UserGroup[]) {
        //var userRole = this.getUserRoleForSensor(sensor, userName, userGroups);
        var [userRole, userGroupName] = this.getUserRole(sensor.userGroupId, sensor.userName, userName, userGroups);
        sensor.userGroup = userGroupName;

        sensor.userFeatureAccess = {};
    
        sensor.userFeatureAccess["EditSensor"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW || sensor.userName == undefined) ? true : false;
    
        sensor.userFeatureAccess["DeleteSensor"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW || sensor.userName == undefined) ? true : false;
    
        sensor.userFeatureAccess["EditSensorName"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW || sensor.userName == undefined) ? true : false;
    
        sensor.userFeatureAccess["EditSensorBrand"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW || sensor.userName == undefined) ? true : false;
    
        sensor.userFeatureAccess["EditSensorCalibration"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW || sensor.userName == undefined) ? true : false;
    
        sensor.userFeatureAccess["ViewSensor"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead || sensor.userName == undefined) ? true : false;
    
        sensor.userFeatureAccess["ViewListing"] =
                    (userRole == UserAccessRole.SiteAdmin ||
                    userRole == UserAccessRole.GroupFullRW ||
                    userRole == UserAccessRole.GroupLimitedRW ||
                    userRole == UserAccessRole.GroupRead ||
                    userRole == UserAccessRole.ViewListing ||
                    globalSwitch || sensor.userName == undefined) ? true : false;
    }
    
    //--------------------

        
    getUserRole(assignedUserGroupID: number, assignedUserName: string, loggedInUser: string, userGroups: UserGroup[]): [UserAccessRole, string] {
        var userRole: UserAccessRole = UserAccessRole.Unassigned;
        var userGroupName: string = 'unknown';

        if (assignedUserGroupID != null) {
            var userGroup = userGroups.find(u => u.id == assignedUserGroupID);

            if (userGroup != undefined) {
                userGroupName = userGroup.name;
                var userInGroup = userGroup.userInfos.find(u => u.userName.toLowerCase() == loggedInUser.toLowerCase());

                if (userInGroup != undefined) {
                    userRole = userInGroup.role;
                }
            }
        }
        else if (assignedUserName != undefined && assignedUserName.toLowerCase() == loggedInUser.toLowerCase()) {
            userRole = UserAccessRole.GroupFullRW;
        }

        var adminRole = this.isUserInAdmins(loggedInUser, userGroups);
        if (adminRole != UserAccessRole.Unassigned) {
            userRole = adminRole;
        }

        return [userRole, userGroupName];
    }


    isUserInAdmins(userName: string, userGroups: UserGroup[]): UserAccessRole {
        var userRole: UserAccessRole = UserAccessRole.Unassigned;

        var userGroup = userGroups.find(x => x.name.toLowerCase() === 'admins');

        if (userGroup == undefined) {
            return userRole;
        }

        var userInGroup = userGroup.userInfos.find(u => u.userName.toLowerCase() === userName.toLowerCase());

        if (userInGroup == undefined) {
            return userRole;
        }
        else {
            return userInGroup.role;
        }
    }

    //--------------------


}